"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchClient = void 0;
var lite_1 = __importDefault(require("algoliasearch/lite"));
var wrapAlgoliaSearch_1 = require("./wrapAlgoliaSearch");
__exportStar(require("algoliasearch/lite"), exports);
var searchClient = function (appId, apiKey, options) {
    var algoliaClient = (0, lite_1.default)(appId, apiKey, options);
    return __assign(__assign({}, algoliaClient), { initIndex: (0, wrapAlgoliaSearch_1.wrapAlgoliaInitIndex)(algoliaClient.initIndex), search: (0, wrapAlgoliaSearch_1.wrapAlgoliaSearch)(algoliaClient.search) });
};
exports.searchClient = searchClient;
exports.default = exports.searchClient;
//# sourceMappingURL=lite.js.map